import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var Container = function Container(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? "section" : _ref$as;
  var Comp = as;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Comp, {
    className: twMerge("max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1275px] 2xl:max-w-[1320px] mx-auto", className)
  }, children));
};
export default Container;